import { GalleryView, PLATFORM_OVERLAY_SMALL } from "@gaming/srvg-classes-core";
import { StatisticsH2hWidget } from "../../widgets/View/VfWidget/StatisticsH2hWidget";
import { StatisticsTeamformWidget } from "../../widgets/View/VfWidget/StatisticsTeamformWidget";
import { StatisticsTotalgoalsWidget } from "../../widgets/View/VfWidget/StatisticsTotalgoalsWidget";
import { StatisticsTotalgoalsDonutsWidget } from "../../widgets/View/VfWidget/StatisticsTotalgoalsDonutsWidget";
import { StatisticsRankingWidget } from "../../widgets/View/VfWidget/StatisticsRankingWidget";

export class TeamStatisticsGalleryView extends GalleryView {

    constructor( options ) {
        options = options || {};
        super( options );
    }

    handleDomInstantiated() {
        super.handleDomInstantiated();
        this.galleryPageContainerView.numberOfItemsToShow = 1;
        var numberOfStatistics = 0;

        if( srvg.widgets.enabled ) {
            // show statistic widgets in the pre match overlay with head to head, but only if it is enabled (see config)
            if (srvg.widgets.widgets['statistics-head2head'].enabled){
                this.addGalleryItem(new StatisticsH2hWidget({
                    widgetGroup: srvg.widgets.widget_group,
                    selector: this.selector + ' .widgetHeadToHead',
                    platform: PLATFORM_OVERLAY_SMALL,
                    zoom: srvg.widgets.zoom,
                    zoomPosition: srvg.widgets.zoom_position,
                    showHeader: srvg.widgets.show_header,
                    showAbbreviations : srvg.widgets.show_abbreviations,
                    template: app.templateEngine.template( StatisticsH2hWidget )
                }));
                numberOfStatistics++;
            }

            // show statistic widgets in the pre match overlay with team form, but only if it is enabled (see config)
            if (srvg.widgets.widgets['statistics-teamform'].enabled){
                this.addGalleryItem(new StatisticsTeamformWidget({
                    widgetGroup: srvg.widgets.widget_group,
                    selector: this.selector + ' .widgetTeamForm',
                    platform: PLATFORM_OVERLAY_SMALL,
                    zoom: srvg.widgets.zoom,
                    zoomPosition: srvg.widgets.zoom_position,
                    showHeader: srvg.widgets.show_header,
                    showAbbreviations : srvg.widgets.show_abbreviations,
                    template: app.templateEngine.template( StatisticsTeamformWidget )
                }));
                numberOfStatistics++;
            }

            // show statistic widgets in the pre match overlay with total goals, but only if it is enabled (see config)
            if (srvg.widgets.widgets['statistics-totalgoals'].enabled){
                this.addGalleryItem(new StatisticsTotalgoalsWidget({
                    widgetGroup: srvg.widgets.widget_group,
                    selector: this.selector + ' .widgetTotalGoals',
                    platform: PLATFORM_OVERLAY_SMALL,
                    zoom: srvg.widgets.zoom,
                    zoomPosition: srvg.widgets.zoom_position,
                    showHeader: srvg.widgets.show_header,
                    showAbbreviations : srvg.widgets.show_abbreviations,
                    template: app.templateEngine.template( StatisticsTotalgoalsWidget )
                }));
                numberOfStatistics++;
            }

            // show statistic widgets in the pre match overlay with total goals, but only if it is enabled (see config)
            if (srvg.widgets.widgets['statistics-totalgoals-donuts'].enabled){
                this.addGalleryItem(new StatisticsTotalgoalsDonutsWidget({
                    widgetGroup: srvg.widgets.widget_group,
                    selector: this.selector + ' .widgetTotalGoalsDonuts',
                    platform: PLATFORM_OVERLAY_SMALL,
                    zoom: srvg.widgets.zoom,
                    zoomPosition: srvg.widgets.zoom_position,
                    showHeader: srvg.widgets.show_header,
                    showAbbreviations : srvg.widgets.show_abbreviations,
                    template: app.templateEngine.template( StatisticsTotalgoalsDonutsWidget )
                }));
                numberOfStatistics++;
            }

            // show statistic widgets in the pre match overlay with total goals, but only if it is enabled (see config)
            if (srvg.widgets.widgets['statistics-ranking'].enabled){
                this.addGalleryItem(new StatisticsRankingWidget({
                    widgetGroup: srvg.widgets.widget_group,
                    selector: this.selector + ' .widgetRanking',
                    platform: PLATFORM_OVERLAY_SMALL,
                    zoom: srvg.widgets.zoom,
                    zoomPosition: srvg.widgets.zoom_position,
                    showHeader: srvg.widgets.show_header,
                    showAbbreviations : srvg.widgets.show_abbreviations,
                    template: app.templateEngine.template( StatisticsRankingWidget )
                }));
                numberOfStatistics++;
            }
        }
        this.pagerView.setLength( numberOfStatistics );
        this.pagerView.selectIndex( 0 );
    }
}